import { Lock } from "lucide-react";
import { Reveal } from "./motion-primitives";
import { SectionLabel } from "./About";
import { useLang, Rich } from "@/i18n/LanguageContext";

const AFRICA_IMG = "/images/osrelis-12.jpg";

export const Opportunities = () => {
  const { c } = useLang();
  const o = c.opportunities;
  return (
    <section id="opportunities" data-testid="section-opportunities" className="relative overflow-hidden bg-deep px-6 py-24 text-paper md:px-[8vw] md:py-32">
      <div className="pointer-events-none absolute right-0 top-0 h-full w-[45%]" style={{ background: "radial-gradient(circle at 60% 45%, rgba(78,123,116,.18), transparent 44%)" }} />
      <div className="relative">
        <Reveal>
          <SectionLabel n="05" onDark>{o.label}</SectionLabel>
        </Reveal>
        <div className="grid gap-12 md:grid-cols-[1.05fr_0.95fr] md:gap-[11vw]">
          <Reveal>
            <h2 className="font-serif text-[clamp(44px,5.2vw,80px)] font-normal leading-[0.98] tracking-[-0.02em]">
              <Rich text={o.title} />
            </h2>
          </Reveal>
          <Reveal delay={0.12} className="max-w-[590px] pt-2">
            <p className="mb-6 font-sans text-[15px] leading-[1.8] text-paper/60">{o.p1}</p>
            <p className="font-sans text-[15px] leading-[1.8] text-paper/60">{o.p2}</p>
          </Reveal>
        </div>

        <Reveal className="mt-16 overflow-hidden md:mt-20">
          <div className="group relative h-[280px] w-full overflow-hidden md:h-[420px]">
            <img src={AFRICA_IMG} alt="Onshore drilling rig operation with field crew" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" style={{ filter: "saturate(0.8) contrast(1.03)" }} />
            <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, rgba(6,18,21,.7), rgba(6,18,21,.1))" }} />
          </div>
        </Reveal>

        <Reveal className="mt-12 flex flex-wrap gap-2.5">
          {o.tags.map((t) => (
            <span key={t} className="border border-paper/20 px-3.5 py-2.5 font-sans text-[10px] uppercase tracking-[0.1em] text-paper/80">
              {t}
            </span>
          ))}
        </Reveal>

        <Reveal className="mt-16 flex flex-col gap-4 border-t border-paper/15 pt-6 md:flex-row md:gap-12">
          <span className="flex items-center gap-2 font-sans text-[10px] uppercase tracking-[0.14em] text-sage">
            <Lock size={12} /> {o.confTag}
          </span>
          <p className="font-sans text-[11px] text-paper/50">{o.confText}</p>
        </Reveal>
      </div>
    </section>
  );
};
